import { useAuthService } from '@/utils/useAuthService';
import { useNavigate } from '@/utils/useNavigate';
import { DownOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons/lib/components/Icon';
import { useEmotionCss } from '@ant-design/use-emotion-css';
import { useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Dropdown, Space, theme, Typography } from 'antd';
import { useMemo } from 'react';
import { LogOutSvg, UserSvg } from '../../../../assets/icon';

const { Text } = Typography;
const { useToken } = theme;

enum UserMenuItemKey {
  PersonalCenter = 'PersonalCenter',
  LogOut = 'LogOut',
}

export const User = () => {
  const { token } = useToken();
  const { logout } = useAuthService();
  const { initialState } = useModel('@@initialState');
  const navigate = useNavigate();
  const wrapClassName = useEmotionCss(() => {
    return {
      display: 'flex',
      alignItems: 'center',
      height: '54px',
      lineHeight: '54px',
      cursor: 'pointer',
    };
  });

  const items: MenuProps['items'] = useMemo(
    () => [
      {
        key: UserMenuItemKey.PersonalCenter,
        label: (
          <Space align="center" size={12}>
            <Icon component={UserSvg} />
            <Text>个人中心</Text>
          </Space>
        ),
      },
      // {
      //     key: '2',
      //     label: (
      //         <Space align="center" size={12}>
      //             <Icon component={CommentSvg} />
      //             帮助与反馈
      //         </Space>
      //     ),
      // },
      {
        key: UserMenuItemKey.LogOut,
        label: (
          <Space size={12}>
            <Icon component={LogOutSvg} />
            退出
          </Space>
        ),
      },
    ],
    [],
  );

  const onClick = async ({ key }: { key: string }) => {
    if (key === UserMenuItemKey.PersonalCenter) {
      navigate('/personalCenter');
    } else if (key === UserMenuItemKey.LogOut) {
      await logout();
      navigate('/login');
    }
  };

  return (
    <Space className={wrapClassName}>
      <Dropdown menu={{ items, onClick }}>
        <Space>
          <span
            style={{
              position: 'relative',
              top: '2px',
              color: token.colorTextSecondary,
            }}
          >
            <UserSvg />
          </span>
          <Text style={{ color: token.colorTextSecondary }}>
            {initialState?.name}
          </Text>
          <DownOutlined />
        </Space>
      </Dropdown>
    </Space>
  );
};
